<template>
  <v-dialog
    v-if="user && localOrderId && localOrder"
    max-width="500"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    :value="dialog"
    @input="$store.commit('orders/CLOSE_ORDER_RECEIVED_DIALOG')"
  >
    <v-card class="px-7 py-10">
      <CloseDialogButton
        :close="() => $store.commit('orders/CLOSE_ORDER_RECEIVED_DIALOG')"
      />
      <v-row no-gutters>
        <v-col class="text-center pt-10">
          <div
            class="font-size-lg font-weight-semibold mb-5 e2e-received-orderid"
          >
            Order #{{ getOrderId() }} Received!
          </div>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col class="d-flex justify-center">
          <StorefrontImage class="display-none-height mb-5" size="large" />
        </v-col>
      </v-row>
      <v-row>
        <v-col class="d-flex justify-center">
          <div
            class="font-size-xl font-weight-semibold line-height-1 text-center e2e-received-name"
          >
            {{ wait(storeInfo, "name") }}
          </div>
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col class="d-flex justify-center line-height-1">
          <StoreAddress class="mb-8 e2e-received-address" :lines="2" />
        </v-col>
      </v-row>

      <v-row no-gutters v-if="order.alcoholOrTobaccoProduct">
        <v-col class="align-center d-flex justify-center mb-8">
          <v-icon class="mdi-card-account-details-outline"
            >mdi-card-account-details-outline
          </v-icon>
          <span
            class="font-size-lg-res font-weight-semibold line-height-1 ml-8 text-center e2e-received-reminder"
          >
            Remember to
            <br />present your ID
          </span>
        </v-col>
      </v-row>

      <v-row no-gutters>
        <v-col
          class="text-center mb-5"
          :cols="order.alcoholOrTobaccoProduct ? 6 : 12"
        >
          <div class="color-suva-grey">{{ renderServiceType() }} Date</div>
          <div class="font-size-lg-res e2e-received-pickup-date">
            {{ localOrderDate }}
          </div>
        </v-col>
        <v-col
          class="text-center mb-5"
          :cols="order.alcoholOrTobaccoProduct ? 6 : 12"
        >
          <div class="color-suva-grey">{{ renderServiceType() }} Time</div>
          <div class="font-size-lg-res e2e-received-pickup-time">
            {{ renderOrderTime(localOrderTime) }}
          </div>
        </v-col>
      </v-row>

      <v-row no-gutters>
        <v-col class="text-center mb-8">
          <div class="color-suva-grey">Payment</div>
          <div class="font-size-lg-res e2e-received-payment-type">
            {{ renderPaymentType() }}
          </div>
        </v-col>
      </v-row>

      <v-row no-gutters>
        <v-col class="text-center">
          <v-btn
            color="primary"
            height="48"
            width="180"
            rounded
            @click.stop="$store.commit('orders/CLOSE_ORDER_RECEIVED_DIALOG')"
          >
            <div class="font-size-md text-capitalize e2e-received-done">
              done!
            </div>
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from "vuex";
import { twentyFourHourToAmPm, wait } from "@/util.js";
import CloseDialogButton from "@/components/UI/CloseDialogButton.vue";
import StoreAddress from "@/components/TopStrip/StoreAddress.vue";
import StorefrontImage from "@/components/UI/StorefrontImage.vue";
import { getUrlParams, renderPickupDate, setLocalOrder } from "@/helper";

//local testing
//const delay = (ms) => new Promise((res) => setTimeout(res, ms));

export default {
  name: "OrderReceivedDialog",
  components: {
    CloseDialogButton,
    StoreAddress,
    StorefrontImage,
  },
  computed: {
    ...mapState({
      user: (state) => state.user.info,
      dialog: (state) => state.orders.dialog.orderReceived,
      order: (state) => state.orders.order,
      storeInfo: (state) => state.store.info,
      localOrderDate: (state) => state.orderStatus.localOrderDate,
      localOrderTime: (state) => state.orderStatus.localOrderTime,
    }),
  },
  async mounted() {
    //local testing
    // await delay(15000);
    await this.setLocalParams();
  },
  methods: {
    addOrderToOrderHistory() {
      this.$store.commit("orders/ADD_ORDER", this.localOrder);
    },
    renderPickupDate,
    setLocalOrder,

    async setLocalParams() {
      const params = getUrlParams();
      // First make sure we have an order id
      this.localOrderId = params.orderId || this.order.id;

      if (!this.localOrderId) return;
      // Make sure that we have an order. If it was cleared by a refresh, pull it from the db
      await this.setLocalOrder();
      if (!this.localOrder) {
        await this.$router.replace("home");
        return;
      }

      this.addOrderToOrderHistory();
      await this.renderPickupDate(this.localOrder, this.storeInfo.tz);
      this.isMounted = true;
    },

    renderPaymentType() {
      return this.order.noCC ? "Pay in Store" : "Paid with Credit Card";
    },
    getOrderId() {
      return this.order.id ? this.order.id : this.localOrderId;
    },

    renderOrderTime(localOrderTime) {
      const selectedTime = localOrderTime || this.order.selectedTime.time;
      if (!selectedTime) return;
      return this.twentyFourHourToAmPm(selectedTime);
    },

    renderServiceType() {
      return this.order.service === "DELIVERY" ? "Delivery" : "Pick-Up";
    },
    twentyFourHourToAmPm,
    wait,
  },
  data() {
    return {
      localOrderId: null,
      localOrder: null,
      isMounted: false,
    };
  },
  watch: {
    async dialog(visible) {
      if (visible && this.isMounted) {
        await this.setLocalParams();
      }
    },
  },
};
</script>

<style scoped>
.mdi-card-account-details-outline {
  color: black;
  font-size: 65px;
}

@media (max-height: 768px) {
  .display-none-height {
    display: none;
  }
}
</style>
